import { faBug } from '@fortawesome/pro-solid-svg-icons';
import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';

import { LS_BADGE_CACHE, LS_LNG_CONTENT, LS_LNG_INTERFACE, LS_USER_CACHE } from '../../../config';
import Button from '../Button';
import Error from '../Error';

import * as style from './style.module.css';

class SentryErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, eventId: null };
    this.lock = false;
  }

  componentDidCatch(error, errorInfo) {
    if (!this.lock) {
      this.lock = true;
      Sentry.withScope((scope) => {
        scope.setExtras(errorInfo);
        const exception = error.originalError || error.error || error;
        if (exception && exception.message) {
          const eventId = Sentry.captureException(exception);
          this.setState({ eventId });
        }
      });
    }
    this.setState({ error });
  }

  render() {
    const { error } = this.state;
    const { children, t } = this.props;

    const flushCache = async () => {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
      [LS_LNG_CONTENT, LS_LNG_INTERFACE, LS_USER_CACHE, LS_BADGE_CACHE].forEach((key) => localStorage.removeItem(key));
      document.location.href = '/';
    }

    if (error) {
      return (
        <div className={style.container}>
          <Error icon={faBug} message={t('A significant error has occurred.')} code={error.toString()} disableMargin />
          <div className={style.buttons}>
            <Button
              label={t('Reload the app')}
              theme="SECONDARY"
              action={flushCache}
            />
          </div>
        </div>
      );
    }
    return children;
  }
}

SentryErrorBoundary.propTypes = {
  children: PropTypes.any.isRequired,
};

export default withTranslation()(SentryErrorBoundary);
